







































import { Component, Vue } from "vue-property-decorator";
import { Getter, State, Mutation } from "vuex-class";

@Component
class BalanceCard extends Vue {
  @Getter("wallet/mixin/getTotalUsd") totalUsd;

  @Getter("auth/isLogged") isLogged;

  @Getter("basis/account/isMixinBinded") isMixinBinded;

  @Mutation("wallet/mixin/SET_HIDDEN") setHidden;

  @State(state => state.wallet.mixin.hidden) hidden;

  get meta() {
    return {
      background: require("@/assets/images/background_1.png"),
      icon: "$vuetify.icons.iconMixin",
      iconPng: require("@/assets/images/icon_mixin.png"),
      title: this.$t("wallet.mixin"),
      type: "mixin",
      name: "Mixin",
      logged: this.isLogged,
      totalBtc: this.totalBtc,
      totalUsd: this.totalUsd
    };
  }

  get totalLegal() {
    const totalUSDT = this.totalUsd;
    const totalUSD = this.$common.utils.currency.fiat(this, {
      value: totalUSDT,
      from: "USD"
    });
    return this.hidden ? "****" : `≈${totalUSD}`;
  }

  get totalBtc() {
    const totalUSDT = this.totalUsd;
    const totalBtc = this.$common.utils.currency.transfer(this, {
      from: "USD",
      to: "BTC",
      value: totalUSDT,
      precision: 8
    });
    return this.hidden ? "********" : `≈${totalBtc} BTC`;
  }

  handleClick() {
    if (!this.meta.logged) {
      this.$emit("login", this.meta.type);
    }
  }
}
export default BalanceCard;
